import CityPageTemplate from "../city-template/CityPageTemplate";
import { hendersonNVConfig } from "./data";

export default function HendersonNVPage() {
  return <CityPageTemplate config={hendersonNVConfig} />;
}